import React from "react";
import { Grid, Hidden } from "@material-ui/core";
import MedibuddyLogo from "./medibuddyFooter.png";
import AdityaBirla from "./adityabirla.png";
import Stick from "./stick.png";
import phoneIcon from "./phoneIcon.png";
import emailIcon from "./emailIcon.png";

const CustomFooter = () => (
  <Grid container alignItems="center" style={{ padding: "2% 0% 2% 0%" , margin:"2% 0% 2% 0%"}} spacing={2}>
    <Hidden xsDown>
      {/* Content for larger screens (md and above) */}
      <Grid item md={6} lg={6} container alignItems="center" justifyContent="flex-end" spacing={2}>
        <Grid item>
          <p style={{ margin: 0 }}>Thank you for choosing</p>
        </Grid>
        <Grid item>
          <img src={MedibuddyLogo} alt="Medibuddy Logo" width="110" height="23" />
        </Grid>
        <Grid item>
          <img src={AdityaBirla} alt="Aditya Birla Logo" width="110" height="23" />
        </Grid>
        <Grid item>
          <img src={Stick} alt="Stick" height="30" />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} container alignItems="center" justifyContent="flex-start">
      {/* Content for all screens */}
      <Grid item>
        <img src={phoneIcon} alt="Phone Icon" height={15} width={15} style={{ marginRight: "10px" }} />
        <span>080 4568 6596</span>
      </Grid>
      <Grid item>
        <img
          src={emailIcon}
          alt="Email Icon"
          height={15}
          width={20}
          style={{ marginLeft: "10px", marginRight: "10px" }}
        />
        <span>doctorconsultations@medibuddy.in</span>
      </Grid>
    </Grid>
    </Hidden>



    <Hidden smUp>
      {/* Content for smaller screens (xs and below) */}
      <Grid item xs={12} container justifyContent="center" >
        <p style={{ margin: '0px 10px 0px 0px', fontSize: 10, fontWeight: 500}}>Thank you for choosing</p>
        <img src={MedibuddyLogo} alt="Medibuddy Logo" width="80" height="17"  style = {{margin: '0px 10px 0px 0px'}}/>
        <img src={AdityaBirla} alt="Aditya Birla Logo" width="80" height="17" />
        
        {/* <img src={Stick} alt="Stick" height="30" style={{ margin: "10px 0" }} /> */}
      </Grid>
      <Grid item xs={12}  container justifyContent="center" spacing={1} >
      {/* Content for all screens */}
      <Grid item xs={4}>
        <img src={phoneIcon} alt="Phone Icon" height={10} width={10} style={{ marginRight: '8px' }} />
        <span style={{fontSize: 10, fontWeight: 500}}>080 4568 6596</span>
      </Grid>
      <Grid item xs={8} >
        <img
          src={emailIcon}
          alt="Email Icon"
          height={10}
          width={15}
          style={{ marginRight: '8px'}}
        />
        <span style={{fontSize: 10, fontWeight: 500}}>doctorconsultations@medibuddy.in</span>
      </Grid>
    </Grid>
    </Hidden>
  </Grid>
);

export default CustomFooter;
